<div cdkTrapFocus role="dialog" aria-labelledby="modal-header">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-header">
      @if (isEvolviCard) {
        <span i18n="@@EvolviRailRequiresCVV">
          Payment by credit card for this rail journey requires a CVV number.
        </span>
      } @else if (isSabreLCCCard) {
        <span i18n="@@SabreLCCRequiresCVV">
          Payment by credit card for this Sabre LCC flight journey requires a CVV number.
        </span>
      } @else {
        <span i18n="@@PropertyRequiresCVV"> The property you are booking requires a CVV. </span>
      }
    </h3>
    <button type="button" class="close" aria-label="Close" ngbAutoFocus (click)="onCancel()">
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body modal_body_ticket">
    <div class="card-cvv-container">
      <div class="cvv-wrapper">
        <label for="cvv-input" i18n="@@CardCVV">Card CVV</label>:
        <div class="asterisk">*</div>
      </div>
      <div class="input-wrapper">
        <input [(ngModel)]="cvv" id="cvv-input" type="password" />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      id="button_stop_booking"
      appButton="small"
      class="small-button--close"
      aria-label="Stop Booking"
      i18n-aria-label
      (click)="stop()"
      (keydown.enter)="stop()"
      (keydown.space)="stop()"
      i18n="@@StopBooking"
    >
      Stop Booking
    </button>
    <button
      type="button"
      id="button_continue"
      appButton="small"
      aria-label="Continue"
      i18n-aria-label
      [disabled]="!validateCVV(cvv)"
      (click)="submit()"
      (keydown.enter)="submit()"
      (keydown.space)="submit()"
      i18n="@@Continue"
    >
      Continue
    </button>
  </div>
</div>
